export enum ExportType {
    Excel = 1,
    PDF = 2
}

export enum Localization {
    He = 'he',
    En = 'en'
}
